/**
 * Creates a function that will merge the provided value with the state
 * passed to the returned function.
 * 
 * @param {string} keyPath 
 * @param {any} value 
 * @param {boolean} spreadValue 
 */
const setNestedImmutably = (keyPath, value, spreadValue = false) => {
  const setter = (prevState) => {
    const keys = keyPath.split('.');
    const newState = {...prevState};

    let nestedState = newState;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const isLast = i === keys.length - 1;

      if (!isLast) {
        nestedState = nestedState[key] = {...nestedState[key]};
      } else {
        nestedState[key] = spreadValue
          ? {...nestedState[key], ...value}
          : value;
      }
    }

    return newState;
  }

  setter.setWith = (setState) => setState(setter);
  return setter;
}

export {
  setNestedImmutably,
}